import React from "react";
import { Head, usePage } from "@inertiajs/react";
import { GlobalStyle } from "../../constants/global-style";
import ProvideLoggedInUser from "../../providers/ProvideLoggedInUser";
import WebinarShowApp from "../../webinars/App";

// Auto-resolved Inertia page for WebinarsController#show when the
// `webinars_rebrand_v1` FeatureToggle is ON. Legacy Slim view (show_v2)
// is served otherwise; the controller branches on the toggle.
//
// Props (from Rails controller via render_inertia):
//   theme: 'dark' | 'light' — driven by dark_mode_v1 FeatureToggle. Default 'light'.
//   auth_rebrand: boolean — driven by auth_rebrand_v1 FeatureToggle. Used to
//     build the correct /login redirect URL when anonymous users click the CTA.
//   webinar: serialized Homepage::WebinarDetailSerializer output — the full
//     shape the page renders. Anonymous users get a baseline; signed-in users
//     additionally get is_registered/can_cancel/join_url/video_visible/cta
//     branches + engagement booleans.
export default function Show() {
  const {
    theme = "light",
    auth_rebrand: authRebrand = false,
    webinar = {},
  } = usePage().props;

  const title = webinar.title || webinar.topic || "Webinar";
  const metaDescription = (webinar.topic || webinar.description || title).slice(0, 160);

  return (
    <>
      <Head>
        <title>{`${title} — Taxsam Learning Center`}</title>
        <meta name="description" content={metaDescription} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={metaDescription} />
        {webinar.banner_image_url && (
          <meta property="og:image" content={webinar.banner_image_url} />
        )}
        {/* LCP hint: the poster is above-the-fold. */}
        {webinar.banner_image_url && (
          <link rel="preload" as="image" href={webinar.banner_image_url} fetchpriority="high" />
        )}
      </Head>
      <GlobalStyle />
      <ProvideLoggedInUser>
        <WebinarShowApp theme={theme} authRebrand={authRebrand} webinar={webinar} />
      </ProvideLoggedInUser>
    </>
  );
}
